import React from 'react';
import { Dialog, Classes, Icon, Intent } from '@blueprintjs/core';
import style from './index.module.scss';

const Access = ({ onClose }) => {
    return (
        <Dialog isOpen={true} onClose={onClose} className={`${style.dialogStyle} ${style.dialogPaddingBottom}`}>
            <div className={`${Classes.DIALOG_BODY} ${style.extensionDialogBackground}`}>
                <div className={style.spaceBetween} style={{ alignItems: 'flex-start', display: 'flex' }}>
                    <div style={{ textAlign: 'left', width: '100%', display: 'block', color: '#7b61ff', fontWeight: 700, fontSize: '1.3rem' }}>
                        You Do Not Have Privileges To Access<br />Workflow
                    </div>
                    <Icon
                        icon="cross"
                        size={20}
                        intent={Intent.DANGER}
                        onClick={onClose}
                        style={{
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'flex-start',
                            marginLeft: '10px',
                            flexShrink: 0
                        }}
                    />
                </div>
                <div className={style.extensionBorder}></div>
                <div style={{ width: '100%', marginTop: 16, fontSize: '1.05rem', color: '#666', textAlign: 'left', fontWeight: 400 }}>
                   {/* Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed. */}
                </div>
            </div>
        </Dialog>
    );
};

export default Access;
